import { render } from "./VerifiedCellphone.vue?vue&type=template&id=48f1b007"
import script from "./VerifiedCellphone.vue?vue&type=script&lang=js"
export * from "./VerifiedCellphone.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/redpoint-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__